import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import TorquePowerRpmCalculator from '../components/tools/TorquePowerRpmCalculator';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'Torque-Power-RPM Calculator | Powertrain Tools | AUTOXIUM';
const PAGE_DESCRIPTION = 'Calculate torque, RPM, or power from the other two, with automatic unit conversion and a live torque-vs-power-vs-RPM relationship chart.';

const TorquePowerRpmCalculatorPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="torque-power-rpm-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities / Powertrain Tools"
        title="Torque-Power-RPM Calculator"
        description="Calculate any one of Torque, RPM, or Power from the other two, with automatic unit conversion and a live relationship chart."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="torque-power-rpm-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <TorquePowerRpmCalculator />
          <ToolGuideCta guidePath="/tools/torque-power-rpm-calculator/guide" toolName="Torque-Power-RPM Calculator" />
        </div>
      </section>
    </div>
  );
};

export default TorquePowerRpmCalculatorPage;
